import { useMediaQuery } from 'usehooks-ts';

// Keep in sync with the `mobile` mixin in styles/mixins/breakpoints.scss, which styles
// the same breakpoint from CSS.
export const useMobileMediaQuery = () => useMediaQuery('(max-width: 767px)');
